var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Button from "@irati/ui/src/Button";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import { FlexRow, StyledButtonLink } from "./styled";
var UploadedImage = /** @class */ (function (_super) {
    __extends(UploadedImage, _super);
    function UploadedImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadedImage.prototype.render = function () {
        var _a = this.props, clear = _a.clear, uploadedImage = _a.uploadedImage;
        return (React.createElement(React.Fragment, null,
            React.createElement(Para, { flush: true, center: true }, uploadedImage),
            React.createElement(FlexRow, { margin: true },
                React.createElement(CopyToClipboard, { flush: true, text: uploadedImage },
                    React.createElement(Button, { small: true, primary: true },
                        React.createElement(FormattedMessage, { id: "platform.imageUpload.copy" }))),
                React.createElement(StyledButtonLink, { small: true, href: uploadedImage, target: "_blank" },
                    React.createElement(FormattedMessage, { id: "platform.imageUpload.viewInBrowser" })),
                React.createElement(Button, { small: true, onClick: clear },
                    React.createElement(FormattedMessage, { id: "platform.imageUpload.clear" })))));
    };
    return UploadedImage;
}(PureComponent));
export default UploadedImage;
